import { persistReducer, Storage } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ShopReducerState, ShopReducerAction } from './ShopModel'

const initialState: ShopReducerState = {
  contextToken: null,
  selectedUserData: null,
  language: [],
  basketQuantity: 0,
  shopAccess: false,
  customerGroupId: null,
  shopAccessKey: null,
  shopChannelId: null,
  qntmReminder: true,
}
const shopReducer = (state: ShopReducerState = initialState, action: ShopReducerAction): ShopReducerState => {
  switch (action.type) {
    case 'UPDATE_SHOP_AUTH_TOKEN':
      return { ...state, contextToken: action.contextToken ?? null }
    case 'UPDATE_SHOP_SELECTED_USER':
      return { ...state, selectedUserData: action.selectedUserData ?? null }
    case 'UPDATE_SHOP_LANGUAGE':
      return { ...state, language: action.language ?? [] }
    case 'UPDATE_SHOP_BASKET_QUANTITY':
      return { ...state, basketQuantity: action.basketQuantity ?? 0 }
    case 'UPDATE_SHOP_ACCESS':
      return { ...state, shopAccess: action.shopAccess ?? false }
    case 'UPDATE_CUSTOMER_GROUP_ID':
      return { ...state, customerGroupId: action.customerGroupId ?? null }
    case 'UPDATE_SHOP_ACCESS_KEY':
      return { ...state, shopAccessKey: action.shopAccessKey ?? null }
    case 'UPDATE_SHOP_CHANNEL_ID':
      return { ...state, shopChannelId: action.shopChannelId ?? null }
    case 'UPDATE_QNTM_REMINDER':
      return { ...state, qntmReminder: action.qntmReminder ?? true }

    default:
      return state
  }
}

const persistConfig: { key: string; storage: Storage; whitelist: (keyof ShopReducerState)[] } = {
  key: 'shop',
  storage: storage,
  whitelist: [
    'contextToken',
    'language',
    'selectedUserData',
    'basketQuantity',
    'shopAccess',
    'customerGroupId',
    'shopAccessKey',
    'shopChannelId',
    'qntmReminder',
  ],
}

export default persistReducer(persistConfig, shopReducer)
